export const GET_ARCHIVES = "get_archive";
export const STOP_LOADING = "stop_loading";
export const START_LOADING = "start_loading";

